<template>
  <div>
    <module-create-layout>
      <moduleForm :dataContainer="dataContainer" class="mb-3" :edit-mode="false" :formHeader="true" formTitle="Add voip smsdialplan"></moduleForm>
    </module-create-layout>

    <div class="mt-3"></div>
    <module-create-layout>
      <moduleFormDocument :dataContainer="dataContainer" :edit-mode="false" :formHeader="true" formTitle="Add voip dialplan"></moduleFormDocument>
    </module-create-layout>
  </div>
</template>

<script>
    import dataContainer from 'devegram-vue-data-collecter-eui/src/mixins/dataContainer';

    export default {
        mixins: [dataContainer],
        components: {
            moduleForm: () => import('../form-manual/View'),
            moduleFormDocument: () => import('../form-document/View'),
            moduleCreateLayout: () => import('@/modules-config/layouts/create/View.vue')
        },
        data() {
            return {
                dataContainer: this
            }
        }
    }
</script>
